import { useData } from '../../../../contexts/DataContext';
import './style.css'
import React, { useState, useEffect } from 'react';

const MONTHS = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

export default function Compontent({content,first_column_name}) {
  const data = useData()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return (
    <>
      <div>

        {/* Desktop Table View */}
        {!isMobile && (
          <div className="relative overflow-x-auto sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500">
              <thead className="text-xs text-gray-700 bg-gray-50">
                <tr>
                  <th scope="col" className="px-4 py-3">{first_column_name}</th>
                  {MONTHS.map((month) => (
                    <th key={month} scope="col" className="px-4 py-3">{month}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {content.map((i, rowIndex) => (
                  <tr key={rowIndex} className="bg-white border-b">
                    <th scope="row" className="px-4 py-4 font-medium text-gray-900 whitespace-nowrap">
                      {i.name}
                    </th>
                    {i.months.map((f, monthIndex) => (
                      <td key={monthIndex} className="px-4 py-4">
                        {data._cn(f.availableBalance.toFixed(2))}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Mobile Card View */}
        {isMobile && (
          <div className="flex flex-col gap-3 px-2">
            {content.map((i, rowIndex) => (
              <div
                key={rowIndex}
                className="bg-white rounded-lg shadow-sm border border-gray-200 p-4"
              >
                {/* Card title (first column) */}
                <div className="flex justify-between items-start gap-4 pb-2 mb-2 border-b border-gray-200">
                  <span className="text-xs font-medium text-gray-500 uppercase tracking-wide min-w-[100px] shrink-0">
                    {first_column_name}
                  </span>
                  <span className="text-sm font-medium text-gray-900 text-right flex-1 min-w-0 break-words [overflow-wrap:anywhere] whitespace-normal">
                    {i.name}
                  </span>
                </div>

                {/* Month values */}
                {i.months.map((f, monthIndex) => (
                  <div
                    key={monthIndex}
                    className="flex justify-between items-start gap-4 py-1.5 border-b border-gray-100 last:border-b-0"
                  >
                    <span className="text-xs font-medium text-gray-500 uppercase tracking-wide min-w-[100px] shrink-0">
                      {MONTHS[monthIndex]}
                    </span>
                    <span className="text-sm text-gray-900 text-right flex-1 min-w-0 break-words [overflow-wrap:anywhere] whitespace-normal">
                      {data._cn(f.availableBalance.toFixed(2))}
                    </span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}

      </div>
    </>
  );
}